module.exports = __webpack_public_path__ + "assets/rankmath-seo.71cd2b0d.svg";